import { SEND_NOW, UNDO_DONE, UNDO_MOVE, UNDO_SENDING, UNDO_WAITING, UNDO_WINDOW_MS } from './constants';

/**
 * A move waits for its Undo: `title` and `words` say what it will do ("Charmeleon goes to the Bench…"), and `swap`
 * ({ userId, benchPosition }) shows it done on the board meanwhile (SwapPreview).
 */
/**
 * A move waiting for its Undo, shown done on the board meanwhile (`preview`): a `swap` of the active Pokémon with a
 * benched one (SwapPreview), or energy `attach`ed from the hand (AttachPreview).
 */
export const undoWaiting = (title, words, { swap = null, attach = null } = {}) => ({
  type: UNDO_WAITING,
  payload: { title, words, swap, attach, sendsAt: Date.now() + UNDO_WINDOW_MS },
});

/** Takes back the move waiting for its Undo. */
export const undoMove = () => ({
  type: UNDO_MOVE,
});

/** Sends the waiting move now, without waiting out its Undo. */
export const sendNow = () => ({
  type: SEND_NOW,
});

export const undoDone = () => ({
  type: UNDO_DONE,
});

export const undoSending = () => ({
  type: UNDO_SENDING,
});
